import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { DEFAULT_ENABLED_PATHS } from "@/nav/workspaceConfig";

const WorkspaceContext = createContext(null);

export function WorkspaceProvider({ children }) {
  const [enabled, setEnabled] = useState(DEFAULT_ENABLED_PATHS);
  const [pickerOpen, setPickerOpen] = useState(false);

  const toggle = useCallback((path) => {
    setEnabled((prev) => (prev.includes(path) ? prev.filter((p) => p !== path) : [...prev, path]));
  }, []);

  const isEnabled = useCallback((path) => enabled.includes(path), [enabled]);
  const openPicker = useCallback(() => setPickerOpen(true), []);
  const closePicker = useCallback(() => setPickerOpen(false), []);

  const value = useMemo(
    () => ({ enabled, isEnabled, toggle, pickerOpen, openPicker, closePicker }),
    [enabled, isEnabled, toggle, pickerOpen, openPicker, closePicker]
  );

  return <WorkspaceContext.Provider value={value}>{children}</WorkspaceContext.Provider>;
}

export function useWorkspace() {
  const ctx = useContext(WorkspaceContext);
  if (!ctx) throw new Error("useWorkspace must be used within WorkspaceProvider");
  return ctx;
}
